import { useState, useEffect } from 'react'
import fetchThemes from '../helpers/intelligence/fetchThemes'
import { cachedThemes } from '../helpers/intelligence/themesCache'

/**
 * De thema's van de Intelligence-pagina.
 *
 * `loaded` en `isEmpty` zijn eigen toestanden, geen afgeleide van
 * `themes.length`. 'Er zijn geen thema's' is een BEWERING aan de lezer, en die
 * is onwaar zolang de gegevens onderweg zijn of de read geweigerd werd. De
 * volgorde in de UI hoort dus te zijn: eerst 'weet ik niet', dan 'leeg', dan de
 * inhoud.
 *
 * AI-CONTEXT: See docs/pitfalls.md#ui-empty-state-claims-absence-while-loading
 * AI-CONTEXT: See docs/pitfalls.md#state-gate-defaults-open-while-loading
 *
 * @returns {{themes: Array<object>, loading: boolean, loaded: boolean, isEmpty: boolean, error: (Error|null)}}
 */
const useThemes = () => {
    const [themes, setThemes] = useState(/** @type {Array<object>} */([]))
    const [loaded, setLoaded] = useState(false)
    const [error, setError] = useState(/** @type {Error|null} */(null))

    useEffect(() => {
        let cancelled = false
        setLoaded(false)
        setError(null)

        // Gedeeld over de vier pagina's die de lijst nodig hebben (themesCache).
        cachedThemes(() => fetchThemes())
            .then((result) => {
                if (cancelled) return
                setThemes(Array.isArray(result?.themes) ? result.themes : [])
                setLoaded(true)
            })
            .catch((err) => {
                if (cancelled) return
                // Laten zien, niet wegslikken: een geweigerde read mag nooit als
                // 'er zijn geen thema's' op het scherm belanden.
                console.error('useThemes:', err)
                setError(err)
                setThemes([])
                setLoaded(false)
            })

        return () => { cancelled = true }
    }, [])

    return {
        themes,
        loading: !loaded && error === null,
        loaded,
        isEmpty: loaded && themes.length === 0,
        error,
    }
}

export default useThemes
